import QrCodeIcon from "@redotech/redo-icons/qr-code-01.svg";
import { Step } from "@redotech/redo-model/return-flow";
import { licensePlateFromModel } from "@redotech/redo-model/return-flow-step-from-model";
import {
  isLicensePlateStepValid,
  LicensePlateState,
} from "@redotech/redo-model/return-flow-step-valid";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import { produce } from "immer";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const LICENSE_PLATE = (
  Details: React.ComponentType<StepTypeDetailsProps<LicensePlateState>>,
): StepType<LicensePlateState, Step.LicensePlate> => ({
  Details: (props) => React.createElement(Details, props),
  customTitle: (state) => state.customTitle,
  description: (state) =>
    state.scope === "return_item" ? "Per-item" : "Per-return",
  downstream(state) {
    return state.next ? [{ id: state.next }] : [];
  },
  empty: { scope: "return_item" },
  fromModel: (model, id) => licensePlateFromModel(model, id),
  Icon: QrCodeIcon,
  iconColor: "gray",
  layout: () => BlockLayout.FULL,
  maxDownstream: () => 1,
  removeConnection(state, targetStepId) {
    return produce(state, (draft) => {
      if (draft.next === targetStepId) {
        draft.next = undefined;
      }
    });
  },
  stepDeleted(state, stepId) {
    return produce(state, (draft) => {
      if (draft.next === stepId) {
        draft.next = undefined;
      }
    });
  },
  title: "License plate",
  toModel(state, id) {
    return {
      type: Step.LICENSE_PLATE,
      customTitle: state.customTitle,
      next: state.next ? id(state.next) : null,
      scope: state.scope,
    };
  },
  updateConnection(state, handleIndex, targetStepId) {
    if (handleIndex !== 0) {
      throw new Error(
        `Invalid handle index ${handleIndex} for license plate step`,
      );
    }
    return produce(state, (draft) => {
      draft.next = targetStepId;
    });
  },
  valid: (state) => isLicensePlateStepValid(state).valid,
});

export { type LicensePlateState } from "@redotech/redo-model/return-flow-step-valid";
